import * as React from 'react'

import { SectionLayout } from './styles'

export const Right: React.FC<{ children?: React.ReactNode }> = ({ children, ...rest }) => (
  <SectionLayout role='region' aria-label='Right Site Header' location='right' {...rest}>
    {children}
  </SectionLayout>
)
